module.exports = __webpack_public_path__ + "img/rank-3.377b07d3.png";